/* eslint-disable no-underscore-dangle */
import { ReactNode } from 'react';

import { NodeKey, DecoratorNode, LexicalEditor } from 'lexical';

import { File } from '../../plugins';

import { $createFileNode, $isFileNode } from './FileNode.helpers';

type SerializedFileNode = {
  type: 'file';
  version: 1;
  id: string;
  name: string;
  size: number;
};

export class FileNode extends DecoratorNode<ReactNode> {
  id: string;

  name: string;

  size: number;

  static getType(): string {
    return 'file';
  }

  static clone(node: FileNode): FileNode {
    return new FileNode(node.id, node.name, node.size, node.__key);
  }

  constructor(id: string, name: string, size: number, key?: NodeKey) {
    super(key);
    this.id = id;
    this.name = name;
    this.size = size;
  }

  getId(): string {
    return this.id;
  }

  createDOM(): HTMLElement {
    const dom = document.createElement('span');
    dom.style.display = 'inline-block';
    dom.dataset.fileId = this.id;
    return dom;
  }

  updateDOM(prevNode: FileNode, dom: HTMLElement): boolean {
    if (!$isFileNode(prevNode)) return true;

    const propertiesChanged =
      this.id !== prevNode.id ||
      this.name !== prevNode.name ||
      this.size !== prevNode.size;

    if (this.id !== prevNode.id) {
      dom.setAttribute('data-file-id', this.id);
    }

    return propertiesChanged;
  }

  decorate(editor: LexicalEditor): ReactNode {
    return (
      <File
        id={this.id}
        name={this.name}
        size={this.size}
        editable={editor._editable}
      />
    );
  }

  exportJSON(): SerializedFileNode {
    return {
      type: 'file',
      version: 1,
      id: this.id,
      name: this.name,
      size: this.size,
    };
  }

  static importJSON(serializedNode: SerializedFileNode): FileNode {
    return $createFileNode(
      serializedNode.id,
      serializedNode.name,
      serializedNode.size,
    );
  }
}
